import { getFullServices } from 'store/ProductDetails/selectors';
export const selectServiceById = (state, sericeId) => {
  const services = getFullServices(state);
  const foundService = services?.find((service) => service?.id === sericeId);

  return foundService;
};
